<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
import ContactCovid from './views/ContactCovid.vue'
import {
  Component,
  Vue
  // Watch
} from 'vue-property-decorator'

@Component({
  components: {
    ContactCovid
  }
})

export default class App extends Vue {

}
</script>

<style>
html {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 100%;
}

#app {
  padding: 50px;
    font-family: 'Titillium Web', "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #444;
}
body {
  font-family: 'Titillium Web', AvenirNext, "Avenir", Helvetica, Arial, sans-serif;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
</style>
